import React, { Component } from "react";
import moment from "moment";
import { Grid, Row, Col, Modal, Button } from "react-bootstrap";
import HmacSHA256 from "crypto-js/hmac-sha256";
import { Card } from "../components/Card/Card";
import { StatsCard } from "../components/StatsCard";
import LoadingSpinner from "../components/Input/LoadingSpinner";
import DatePicker from "react-date-picker";
import { CSVLink } from "react-csv";
import axios from "axios";

import "../assets/css/grid.css";
import ReactTable from "react-table";
import "../assets/css/Modal.css";


var legendPie = {
  names: [
    "Porosi Te Krijuara",
    "Grumbullime",
    "Dorezime",
    "MosDorezime",
    "Pode deleguar korrier", 
    "Kthime ne Klient",
    "Objekti ne Destinacion për Dorëzim",
    "Likuiduar",
    
  ],
  types: ["icon-a", "icon-b", "icon-c", "icon-d", "icon-e", "icon-f", "icon-g","icon-h","icon-i"],
  
};

const kodeProdukte = [
  { value: "1", label: "D2D" },
  { value: "2", label: "P2P" },
  { value: "3", label: "D2DK" },
  { value: "4", label: "P2PK" },
  { value: "5", label: "Te Gjitha" },
];
const yesterday = new Date();
const today = new Date();
yesterday.setDate(yesterday.getDate() - 7);
today.setDate(today.getDate());
class DashboardAgjent extends Component {
  state = {
    posts: [],
    postsGjurmo: [],
    listpodesh: [],
    postsLikuidime: [],
    number: "",
    number1: "",
    number2: "",
    number3: "",
    number4: "",
    number5: "",
    number6: "",
    number7: "",
    number8: "",
    number9: "",
    number10: "",
    number11: "",
    data8: "",
    testvar:false,
    showModal: false,
    showModalGjurmo:false,
    showModalLikuidime: false,
    show: false,
    showlikujdime: false,
    showlikujdime2: false,
    pDeri:today,
    //
    date: new Date(),
    dataCity: "",
    pNga: yesterday,
    statusi: "",
  
    qytetiOrigjine: "",
    qytetiDestinacion: "",
    KlientSubjektEmri: "",
    KlientSubjektID: "",
    Pershkrimi: "",
    nrPod: "",
    dataPosts: [],
    nrKodi: "",
    cmimiBaze: "",
    kushPaguan: "",
    Token: "",
    username: "",
    pStatus: "",
    emriMarresit: "",
    Total: "",
    VleraKP: "",
    TotalVP: "",
    TotalKP: "",
    check:0,
    TotalLek: "",
    resPorosiKrijuar: [],
    tablesize:0,
    //
    KodiProduktit: kodeProdukte[4],
    KodLevizje: { value: "True", label: "Te Gjitha" },
    KlienteSubjekte: { value: "True", label: "Te Gjitha" },
    klientSubjektEmri: window.UserP.usernameKS,
    loading: false,
    loadingModal: false,
    dataPie: {
      labels: ["", "", "", ""],
      series: [
        []
      ],
      
    },
    optionss : {
      innerWidth:10,
      distributeSeries: true,
      axisX: {
        labelInterpolationFnc: function(value, index) {
          return index % 1 === 0 ? value : null;
        }
      }
    },
    smthcolor: {
      distributeSeries: true
    },

    _isMounted: true,
  };

  onChangeFunc = (name) => (value) => {
    this.setState({
      [name]: value,
    });
  };

  convertToDropDown = (par) => {
    var ret = [];
    var paramArray = par;

    for (var i in paramArray) {
      var objItem = { value: "", label: "" };
      objItem.value = paramArray[i];
      objItem.label = paramArray[i];
      ret.push(objItem);
    }

    return ret;
  };

  hideModal = () => {
    this.setState({ show: false });
  };
  hideModalLikujdime = () => {
    this.setState({ showlikujdime: false });
  };
  hideModalLikujdime2 = () => {
    this.setState({ showlikujdime2: false });
  };
  hideModal2 = () => {
    this.setState({ showModal: false });
  };
  hideModalGjurmo = () => {
    this.setState({ showModalGjurmo: false });
  };
  
  hideModal3 = () => {
    this.setState({ showModalLikuidime: false });
  };
  showModal = () => {
    this.setState({ show: true });
  };
  showModal2 = () => {
    this.setState({ showModal: true });
  };
  showModalGjurmo = () => {
    this.setState({ showModalGjurmo: true });
  };
  
  showModal3 = () => {
    this.setState({ showModalLikuidime: true });
  };

  handleClick = (e) => {
   this.test111();
  };
  onChangeFunc = (name) => (value) => {
    // console.log(value.label);
    this.setState({
      [name]: value,
    });
  };

  handleChange1 = (value) => {
    this.setState({
      pDeri: value,
    });
    this.state.pDeri=value;
    
  };

  handleChange2 = (value) => {
    this.setState({
      pNga: value,
    });
    this.state.pNga=value;
  };

  componentWillMount() {
   
      this.setState({ loading: true }, () =>
       {
        { fetch(window.UserP.url + "POD/TransactionLogObjDestinacioKthimeCount", {
            method: "Post",
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify({
              Token: HmacSHA256(
                Math.round(new Date().getTime() / 1000).toString(),
                window.UserP.key
              ).toString(),
              username: window.UserP.username,
              KlientSubjektEmri: this.state.klientSubjektEmri,

              
            }),
          })
            .then((res) => res.json())
            .then((data) => {
              this.setState({
      
                loading: false,
                number9: data.ResultMessageTotali,
               
              });
            })
            .catch((error) => {
              alert(error + " Ju lutem kontaktoni departamentin e IT!");
              this.setState({
                loading: false              
              });
            });
          }
       { fetch(window.UserP.url + "POD/TransactionLogPorosiTeKrijuaraCount", {
          method: "Post",
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify({
            Token: HmacSHA256(
              Math.round(new Date().getTime() / 1000).toString(),
              window.UserP.key
            ).toString(),
            username: window.UserP.username,
            KlientSubjektEmri: this.state.klientSubjektEmri
            
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            this.setState({
    
              loading: false,
              number: data.ResultMessage,
             
            });
          })
          .catch((error) => {
            alert(error + " Ju lutem kontaktoni departamentin e IT!");
            this.setState({
              loading: false              
            });
          });
        }
          {
            fetch(window.UserP.url + "POD/TransactionLogGrumbullimeCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri
             
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number2: data.ResultMessageTotali,
                
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }

          {
            fetch(window.UserP.url + "POD/TransactionLogVetemPorosiCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                KlientSubjektEmri: this.state.klientSubjektEmri,
                username: window.UserP.username,
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                
                  loading: false,
                  number3: data.ResultMessageTotali,
                 
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }

          {
            fetch(window.UserP.url + "POD/TransactionLogAllDeleguarCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri
             
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number4: data.ResultMessageTotali,
                
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }

          {
            
              fetch(window.UserP.url + "POD/TransactionLogVetemGrmbCount", {
                method: "Post",
                headers: {
                  Accept: "application/json",
                  "Content-type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                },
                body: JSON.stringify({
                  Token: HmacSHA256(
                    Math.round(new Date().getTime() / 1000).toString(),
                    window.UserP.key
                  ).toString(),
                  username: window.UserP.username,
                  KlientSubjektEmri: this.state.klientSubjektEmri
               
                }),
              })
                .then((res) => res.json())
                .then((data) => {
                  this.setState({
                    //listpodesh
                    loading: false,
                    number5: data.ResultMessageTotali,
                  
                  });
                })
                .catch((error) => {
                  alert(error + " Ju lutem kontaktoni departamentin e IT!");
                  this.setState({
                    loading: false              
                  });
                });
            
          }
          {
            
            fetch(window.UserP.url + "POD/TransactionLogAllStatusCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri,
                pStatus:"Deleguar Korrierit"  
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number6: data.ResultMessageTotali,
                 
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          
          }

          {
            fetch(window.UserP.url + "POD/TransactionLogObjDestinacioCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri,
                pStatus:"Deleguar Korrierit"  
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number7: data.ResultMessageTotali,
                 
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }

          {
            fetch(window.UserP.url + "POD/TransactionLogAllStatusCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri,
                pStatus:"Kthyer Mbrapsht"  
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number8: data.ResultMessageTotali,
                 
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }

          {
            fetch(window.UserP.url + "POD/TransactionLogDorezimeCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri,
                pStatus:"Dorezuar ne Klient" ,
                ArsyeMosdorezim:""
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number10: data.ResultMessageTotali,
                 
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }

          {
            fetch(window.UserP.url + "POD/TransactionLogMosDorezimeCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri,
                pStatus:"Dorezuar ne Klient" ,
                ArsyeMosdorezim:""
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number11: data.ResultMessageTotali,
                 
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }
          {
            fetch(window.UserP.url + "POD/TransactionLogMosDorezimeRefCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri,
                pStatus:"Dorezuar Kthimi Mbrapsh ne Klient" ,
                ArsyeMosdorezim:""
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number12: data.ResultMessageTotali,
                 
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }
          {
            fetch(window.UserP.url + "POD/TransactionLogDorezimeCount", {
              method: "Post",
              headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({
                Token: HmacSHA256(
                  Math.round(new Date().getTime() / 1000).toString(),
                  window.UserP.key
                ).toString(),
                username: window.UserP.username,
                KlientSubjektEmri: this.state.klientSubjektEmri,
                pStatus:"Dorezuar Kthimi Mbrapsh ne Klient" ,
                ArsyeMosdorezim:""
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                this.setState({
                  //listpodesh
                  loading: false,
                  number13: data.ResultMessageTotali,
                 
                });
              })
              .catch((error) => {
                alert(error + " Ju lutem kontaktoni departamentin e IT!");
                this.setState({
                  loading: false              
                });
              });
          }
        }
        
        
        );
    
    }
    
  test111 ()
  {
    this.setState({ loading: true }, () =>
    {
        { fetch(window.UserP.url + "POD/TransactionLogObjDestinacioKthimeCount", {
            method: "Post",
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify({
              Token: HmacSHA256(
                Math.round(new Date().getTime() / 1000).toString(),
                window.UserP.key
              ).toString(),
              pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
              username: window.UserP.username,
              KlientSubjektEmri: this.state.klientSubjektEmri
              
            }),
          })
            .then((res) => res.json())
            .then((data) => {
              this.setState({
      
                loading: false,
                number9: data.ResultMessageTotali,
               
              });
            })
            .catch((error) => {
              alert(error + " Ju lutem kontaktoni departamentin e IT!");
              this.setState({
                loading: false              
              });
            });
          }
    { fetch(window.UserP.url + "POD/TransactionLogPorosiTeKrijuaraCount", {
       method: "Post",
       headers: {
         Accept: "application/json",
         "Content-type": "application/json",
         "Access-Control-Allow-Origin": "*",
       },
       body: JSON.stringify({
         Token: HmacSHA256(
           Math.round(new Date().getTime() / 1000).toString(),
           window.UserP.key
         ).toString(),
         pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
         username: window.UserP.username,
         KlientSubjektEmri: this.state.klientSubjektEmri
      
       }),
     })
       .then((res) => res.json())
       .then((data) => {
         this.setState({
 
           loading: false,
           number: data.ResultMessage,
          
         });
       })
       .catch((error) => {
         alert(error + " Ju lutem kontaktoni departamentin e IT!");
         this.setState({
           loading: false              
         });
       });
     }
       {
         fetch(window.UserP.url + "POD/TransactionLogGrumbullimeCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri
          
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number2: data.ResultMessageTotali,
             
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }

       {
         fetch(window.UserP.url + "POD/TransactionLogVetemPorosiCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri
          
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
             
               loading: false,
               number3: data.ResultMessageTotali,
              
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }

       {
         fetch(window.UserP.url + "POD/TransactionLogAllDeleguarCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri
          
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number4: data.ResultMessageTotali,
             
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }

       {
         
           fetch(window.UserP.url + "POD/TransactionLogVetemGrmbCount", {
             method: "Post",
             headers: {
               Accept: "application/json",
               "Content-type": "application/json",
               "Access-Control-Allow-Origin": "*",
             },
             body: JSON.stringify({
               Token: HmacSHA256(
                 Math.round(new Date().getTime() / 1000).toString(),
                 window.UserP.key
               ).toString(),
               pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
               username: window.UserP.username,
               KlientSubjektEmri: this.state.klientSubjektEmri
            
             }),
           })
             .then((res) => res.json())
             .then((data) => {
               this.setState({
                 //listpodesh
                 loading: false,
                 number5: data.ResultMessageTotali,
               
               });
             })
             .catch((error) => {
               alert(error + " Ju lutem kontaktoni departamentin e IT!");
               this.setState({
                 loading: false              
               });
             });
         
       }
       {
         
         fetch(window.UserP.url + "POD/TransactionLogAllStatusCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             username: window.UserP.username,
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             KlientSubjektEmri: this.state.klientSubjektEmri,
             pStatus:"Deleguar Korrierit"  
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number6: data.ResultMessageTotali,
              
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       
       }

       {
         fetch(window.UserP.url + "POD/TransactionLogObjDestinacioCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri,
             pStatus:"Deleguar Korrierit"  
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number7: data.ResultMessageTotali,
              
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }

       {
         fetch(window.UserP.url + "POD/TransactionLogAllStatusCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri,
             pStatus:"Kthyer Mbrapsht"  
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number8: data.ResultMessageTotali,
              
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }

       {
         fetch(window.UserP.url + "POD/TransactionLogDorezimeCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri,
             pStatus:"Dorezuar ne Klient" ,
             ArsyeMosdorezim:""
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number10: data.ResultMessageTotali,
              
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }

       {
         fetch(window.UserP.url + "POD/TransactionLogMosDorezimeCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri,
             pStatus:"Dorezuar ne Klient" ,
             ArsyeMosdorezim:""
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number11: data.ResultMessageTotali,
              
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }
       {
         fetch(window.UserP.url + "POD/TransactionLogMosDorezimeRefCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri,
             pStatus:"Dorezuar Kthimi Mbrapsh ne Klient" ,
             ArsyeMosdorezim:""
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number12: data.ResultMessageTotali,
              
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }
       {
         fetch(window.UserP.url + "POD/TransactionLogDorezimeCount", {
           method: "Post",
           headers: {
             Accept: "application/json",
             "Content-type": "application/json",
             "Access-Control-Allow-Origin": "*",
           },
           body: JSON.stringify({
             Token: HmacSHA256(
               Math.round(new Date().getTime() / 1000).toString(),
               window.UserP.key
             ).toString(),
             pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
             username: window.UserP.username,
             KlientSubjektEmri: this.state.klientSubjektEmri,
             pStatus:"Dorezuar Kthimi Mbrapsh ne Klient" ,
             ArsyeMosdorezim:""
           }),
         })
           .then((res) => res.json())
           .then((data) => {
             this.setState({
               //listpodesh
               loading: false,
               number13: data.ResultMessageTotali,
              
             });
           })
           .catch((error) => {
             alert(error + " Ju lutem kontaktoni departamentin e IT!");
             this.setState({
               loading: false              
             });
           });
       }
     }
     
     
     );
 
  }

  createLegend(p) {
    var legend = [];
    for (var i = 0; i < p["names"].length; i++) {
      var type = "pe-7s-server " + p["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(p["names"][i]);
    }
    return legend;
  }

  
  TestA = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      // pStatus: this.state.pStatus.label,
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };

    let value="";
    
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionLogPorosiTeKrijuaraALL",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            number:tsize.toString(),
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
    
    

   
  }
  TestB = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPOd: this.state.nrPod,
      pStatus: "Grumbulluar",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };

    let value="";
    
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionLogGRumbulluarALL",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:nur,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        }); 
    });
  }
  
  TestC = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Dorezuar ne Klient",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionVetemPorosiALL",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }

  PodeDeleguar = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      // pStatus: "Nuk u Dorezua ne Klient",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionALLDeleguarPod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
         
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }
  //Pode ne HUB
  TestE = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionLogGrumbullimeNew",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:nur,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }
  
  VetemGrumbullim = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Deleguar Korrierit",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionVetemGrmbPod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:nur,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }
  //Pod ne Agjensi
  TestG = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Pode te Kthyer Mbrapsht",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionLogGrumbullimeNew",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:nur,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }
  
  TestH = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Deleguar Korrierit",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionAllStatusPod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }


  KthyerMbrapsht = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Kthyer Mbrapsht",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionAllStatusPod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }

  DorezuarPode = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Dorezuar ne Klient",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionDorezimePod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }
  
  DorezuarPodeKthyerPas = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Dorezuar ne Klient",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionObjDestinacionKthimePod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }

  MosDorezuarPode = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Dorezuar ne Klient",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionMosDorezimePod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }

  MosDorezuarPodeRefuzime = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Dorezuar ne Klient",
      ArsyeMosdorezim:"26",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionMosDorezimRefPod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }


  DorezuarKthimeMbrapaPode = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Dorezuar Kthimi Mbrapsh ne Klient",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionDorezimePod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }

  
  ObjekteNeDestinacion = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "Dorezuar ne Klient",
      ArsyeMosdorezim:"26",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionObjDestinacionRefPod",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:this.state.posts,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }


  //Refuzime
  TestI = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPod: this.state.nrPod,
      pStatus: "",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionLogGrumbullimeNew",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:nur,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        });

          
    });
  }

  TestU = (e) => {
    const ManifestReq = {
      // qytetiOrigjine: this.state.qytetiOrigjine.value,
      // qytetiDestinacion: this.state.qytetiDestinacion.value,
      // statusi: this.state.statusi.label,
      // KlientSubjektEmri: window.UserP.usernameKS,
      // nrPod: this.state.nrPod,
      // pStatus: "Dorezuar Kthimi Mbrapsh ne Klient",
      pNga: moment(this.state.pNga).format("YYYY-MM-DD"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("YYYY-MM-DD"),
      KodAC: window.UserP.usernameKS,
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/RaportLikuidime",ManifestReq

        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:nur,
            tablesize:tsize,
            testvar:true,
            showModalLikuidime: true,
            showlikujdime:true
          });
        });
    });
  }

  GetObjektineDestinacion = (e) => {
    const ManifestReq = {
      qytetiOrigjine: this.state.qytetiOrigjine.value,
      qytetiDestinacion: this.state.qytetiDestinacion.value,
      statusi: this.state.statusi.label,
      KlientSubjektEmri: window.UserP.usernameKS,
      nrPOd: this.state.nrPod,
      pStatus: "Objekti në Destinacion për Dorëzim",
      pNga: moment(this.state.pNga).format("MM/DD/YYYY"), //this.state.pNga.toLocaleDateString(),
      pDeri: moment(this.state.pDeri).format("MM/DD/YYYY"),
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };

    let value="";
    
    this.setState({ loading: true }, () => {
     
      axios
        .post(
          window.UserP.url + "POD/TransactionLogGRumbulluarALL",
          ManifestReq
        )
        .then((response) => {
          this.setState({ posts: response.data, loading: false });
          let nur = [];
          let tsize = this.state.posts.length;
          for (var i = 0; i < tsize; i++) {
            this.state.posts[i].POD = '=""'+this.state.posts[i].POD+'""';

          
            
          }
          
          this.setState({
            tablevalues:nur,
            tablesize:tsize,
            testvar:true,
            showModal: true,
            show:true
          });
        }); 
    });
  }

  handleClickGjurmo = (pod) => {
   
    var d = new Date();

    const data = {
      nrKodi: pod,

       Token: HmacSHA256(
         Math.round(new Date().getTime() / 1000).toString(),
         window.UserP.key
      ).toString(),

       username: window.UserP.username,
    };
   
      //   console.log("token", offset);

      // const headers = {
      //   Accept: "application/json",
      //   "Content-type": "application/json",
      //   "Access-Control-Allow-Origin": "*",
      // };
      this.setState({ loadingModal: true }, () =>
      {
      axios.post(window.UserP.url + "POD/Gjurmo", data).then((response) => {
        this.setState({ postsGjurmo: response.data ,showModalGjurmo:true,loadingModal:false});
        
      });
    });
    
  };


  render()
   {const columns = [
    {
      Header: "Nr",
      headerStyle:{
        color:"#A1A5B7",
        fontWeight: "bold",
        "border-style": "none dotted dotted none",
        "border-width":"2px",
        "border-color": "#eff2f5"
      },
      id: "row",
      filterable: false,
      getProps: (state, rowInfo, column) => {
        return {
            style: {
                background:'#fff',
                color:"#181C32 !important",
                "border-width":"2px",
               
                "border-color":"#eff2f5",
                "border-style": "none none dashed none",
                "font-size": "1.075rem!important",
            },
        };
    },
      Cell: (row) => {
        return <div>{row.index + 1}</div>;
      },
    },
    {
      Header: "Nr.POD",
      
      
      headerStyle:{
        color:"#A1A5B7",
        fontWeight: "bold",
        "border-style": "none dotted dotted none",
        "border-width":"2px",
        "border-color": "#eff2f5"
      },
      accessor: "POD",
      getProps: (state, rowInfo, column) => {
        return {
          
            style: {
                background:'#fff',
                color:"#181C32 !important",
                "border-width":"2px",
                
                "border-color":"#eff2f5",
                "border-style": "none none dashed none",
                "font-size": "1.075rem!important",
            },
        };
    },
    Cell: (row) => {
      return <div><a href="#gjurmim-dashboard" onClick={() => this.handleClickGjurmo(row.original.POD.substr(3,(row.original.POD.length)-5))}>{row.original.POD.substr(3,(row.original.POD.length)-5)}</a></div>;
    },
    },
    {
        Header: "Kod Levizje",
        headerStyle:{
            color:"#A1A5B7",
            fontWeight: "bold",
            "border-style": "none dotted dotted none",
            "border-width":"2px",
            "border-color": "#eff2f5"
          },
        accessor: "Kod_Levizje",
        getProps: (state, rowInfo, column) => {
            return {
                style: {
                    background:'#fff',
                    color:"#181C32 !important",
                    "border-width":"2px",
                    
                    "border-color":"#eff2f5",
                    "border-style": "none none dashed none",
                    "font-size": "1.075rem!important",
                },
            };
        },
      },
    {
      Header: "Pershkrim",
      headerStyle:{
        color:"#A1A5B7",
        fontWeight: "bold",
        "border-style": "none dotted dotted none",
        "border-width":"2px",
        "border-color": "#eff2f5"
      },
      accessor: "Pershkrime",
      getProps: (state, rowInfo, column) => {
        return {
            style: {
                background:'#fff',
                color:"#181C32 !important",
                "border-width":"2px",
                
                "border-color":"#eff2f5",
                "border-style": "none none dashed none",
                "font-size": "1.075rem!important",
            },
        };
    },
    },
    {
        Header: "Vlera e Pakos",
        headerStyle:{
            color:"#A1A5B7",
            fontWeight: "bold",
            "border-style": "none dotted dotted none",
            "border-width":"2px",
            "border-color": "#eff2f5"
          },
        accessor: "VleraKP",
        getProps: (state, rowInfo, column) => {
            return {
                style: {
                    background:'#fff',
                    color:"#181C32 !important",
                    "border-width":"2px",
                    
                    "border-color":"#eff2f5",
                    "border-style": "none none dashed none",
                    "font-size": "1.075rem!important",
                },
            };
        },
      },
    {
      Header: "Agjensia Destinacion",
      headerStyle:{
        color:"#A1A5B7",
        fontWeight: "bold",
        "border-style": "none dotted dotted none",
        "border-width":"2px",
        "border-color": "#eff2f5"
      },
      accessor: "AgjensiaDestinacion",
      getProps: (state, rowInfo, column) => {
        return {
            style: {
                background:'#fff',
                color:"#181C32 !important",
                "border-width":"2px",
                
                "border-color":"#eff2f5",
                "border-style": "none none dashed none",
                "font-size": "1.075rem!important",
            },
        };
    },
    },

    {
      Header: "Agjensia Origjine",
      headerStyle:{
        color:"#A1A5B7",
        fontWeight: "bold",
        "border-style": "none dotted dotted none",
        "border-width":"2px",
        "border-color": "#eff2f5"
      },
      accessor: "Agjensia_qe_Paguan",
      getProps: (state, rowInfo, column) => {
        return {
            style: {
                background:'#fff',
                color:"#181C32 !important",
                "border-width":"2px",
                
                "border-color":"#eff2f5",
                "border-style": "none none dashed none",
                "font-size": "1.075rem!important",
            },
        };
    },
    },
    {
        Header: "Data",
        headerStyle:{
            color:"#A1A5B7",
            fontWeight: "bold",
            "border-style": "none dotted dotted none",
            "border-width":"2px",
            "border-color": "#eff2f5"
          },
        accessor: "Data",
        
        getProps: (state, rowInfo, column) => {
            return {
                style: {
                    background:'#fff',
                    color:"#181C32 !important",
                    "border-width":"2px",
                    
                    "border-color":"#eff2f5",
                    "border-style": "none none dashed none",
                    "font-size": "1.075rem!important",
                },
            };
        },
      },
    
  ];

  const columnsGjurmo = [
    {
      Header: "Kodi",
      accessor: "koditem",
    },
    {
      Header: "Data",
      accessor: "data",
      Cell: (row) => {
        return <div>{row.value.substring(8, 10)+"/"+row.value.substring(5, 7)+"/"+row.value.substring(0, 4)+"   "+row.value.substring(11, 13)+":"+row.value.substring(14, 16)+":"+row.value.substring(17, 19)}</div>;
      },
    },

    {
      Header: "Veprimi",
      accessor: "Veprimi",
    },
    {
      Header: "Canta",
      accessor: "CantaItemKod",
      Cell: (row) => (
        <div>
          <span title={row.value}>{row.value}</span>
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      Header: "Statusi",
      id: "row",
      filterable: false,
      
      headerStyle: {
        
        backgroundColor: '#fff',
        color : 'black',
            fontWeight : 'bold',
            
      },
      getProps: (state, rowInfo, column) => {
        return {
            style: {
                background: rowInfo && rowInfo.index%2 == 1 ? '#FFC107' : rowInfo && rowInfo.index%2 == 0 ? '#28A745':null,
                color:rowInfo && rowInfo.index%2 == 1 ?"black":"white",
            },
        };
    },
      Cell: (row) => {
        return <div>{((row.index%2)==0?"Likuiduar":"Të Palikuiduara")}</div>;
      },
    },
    {
      Header: "Data",
      accessor: "0",
      headerStyle: {
        
        backgroundColor: '#fff',
        color : 'black',
            fontWeight : 'bold',
            
      },
      getProps: (state, rowInfo, column) => {
        return {
            style: {
                background: rowInfo && rowInfo.index%2 == 1 ? '#FFC107' : rowInfo && rowInfo.index%2 == 0 ? '#28A745':null,
                color:rowInfo && rowInfo.index%2 == 1 ?"black":"white",
            },
        };
    },
    },
    {
      Header: "Vlera Likuiduar Total",
      accessor: "1",
      headerStyle: {
        
        backgroundColor: '#fff',
        color : 'black',
            fontWeight : 'bold',
            
      },
      getProps: (state, rowInfo, column) => {
        return {
            style: {
                background: rowInfo && rowInfo.index%2 == 1 ? '#FFC107' : rowInfo && rowInfo.index%2 == 0 ? '#28A745':null,
                color:rowInfo && rowInfo.index%2 == 1 ?"black":"white",
            },
        };
    },
    },
    {
      Header: "Nr. Dergesave",
      accessor: "2",
      headerStyle: {
        
        backgroundColor: '#fff',
        color : 'black',
            fontWeight : 'bold',
            
      },
      getProps: (state, rowInfo, column) => {
        return {
            style: {
                background: rowInfo && rowInfo.index%2 == 1 ? '#FFC107' : rowInfo && rowInfo.index%2 == 0 ? '#28A745':null,
                color:rowInfo && rowInfo.index%2 == 1 ?"black":"white",
            },
        };
    },
    Cell: (row) => {
      return <button style={{"background-color":"#e7e7e7", color: "black",border: 0}} href="#Likujdime-ditore" onClick={() => this.TestLikuidime(row.original[0],row.index)}>{row.original[2]}</button>;
    },
    },
    
    
  ];
  const columns3 = [
    {
      Header: "Nr",

      id: "row",
      filterable: false,

      Cell: (row) => {
        return <div>{row.index + 1}</div>;
      },
    },
    {
      Header: "Nr.POD",
      accessor: "0",

      //  Cell: e => <a href={e.value}>{(onClick = this.showModal())}</a>
    },
    {
      Header: "Data",
      accessor: "1",
    },
    {
      Header: "Vlera",
      accessor: "2",
    },
    {
      Header: "Currency",
      accessor: "3",
    },
  ];
    return (

     
      <Grid fluid>
     
          <div>
            {this.state.loading ? (
              <LoadingSpinner />
            ) : (
              <div>

{this.state.showModal ? (
                              <div>
                                <ModalNew
                                  showModal={this.state.showModal}
                                  loading={this.state.loadingModal}
                                  handleClose={this.hideModal}
                                  vlera={this.state.posts}
                                  className="modal fade docs-example-modal-sm"
                                  tabindex="-1"
                                  role="dialog"
                                  aria-labelledby="mySmallModalLabel"
                                  aria-hidden="true"
                                  show={this.state.show}
                                >
                             
                                { <ReactTable
                                columns={columns}
                                data={this.state.posts}
                                defaultPageSize={10}
                                className="mt-4 mr-4 ml-4"
                                pageText="Faqe"
                                nextText="Para"
                                rowsText="Rreshta"
                                previousText="Mbrapa"
                                noDataText="Nuk ka te dhena"
                                
                              />
                              }
                            
                            
                                </ModalNew> 
                                     </div>): null}
        {this.state.showModalGjurmo ? (
                              <div>
                                <ModalGjurmo
                                  showModal={this.state.showModalGjurmo}
                                  handleClose={this.hideModalGjurmo}
                                  vlera={this.state.posts}
                                  className="modal fade docs-example-modal-sm"
                                  tabindex="-1"
                                  role="dialog"
                                  aria-labelledby="mySmallModalLabel"
                                  aria-hidden="true"
                                  show={this.state.show}
                                >
                             
                                { <ReactTable
                                columns={columnsGjurmo}
                                data={this.state.postsGjurmo}
                                defaultPageSize={10}
                                className="mt-4 mr-4 ml-4"
                                pageText="Faqe"
                                nextText="Para"
                                rowsText="Rreshta"
                                previousText="Mbrapa"
                                noDataText="Nuk ka te dhena"
                                
                              />
                              }
                            
                            
                                </ModalGjurmo> 
                                     </div>): null}

        {this.state.showModalLikuidime ? (
                              <div>
                                <ModalNew
                                  showModal={this.state.showModalLikuidime}
                                  handleClose={this.hideModalLikujdime}
                                  className="modal fade docs-example-modal-sm"
                                  tabindex="-1"
                                  role="dialog"
                                  aria-labelledby="mySmallModalLabel"
                                  aria-hidden="true"
                                  show={this.state.showlikujdime}
                                >
                             
                                { <ReactTable
                                columns={columns2}
                                data={this.state.posts}
                                defaultPageSize={10}
                                className="-striped -highlight mt-4 mr-3 ml-3"
                                pageText="Faqe"
                                nextText="Para"
                                rowsText="Rreshta"
                                previousText="Mbrapa"
                                noDataText="Nuk ka te dhena"
                                
                              />
                              }
                            
                            
                                </ModalNew> 
                                     </div>): null}
                                     {this.state.showModalLikuidimeElse ? (
                              <div>
                                <ModalNew
                                  showModal={this.state.showModalLikuidimeElse}
                                  handleClose={this.hideModalLikujdime2}
                                  className="modal fade docs-example-modal-sm"
                                  tabindex="-1"
                                  role="dialog"
                                  aria-labelledby="mySmallModalLabel"
                                  aria-hidden="true"
                                  show={this.state.showlikujdime2}
                                >
                             
                                { <ReactTable
                                columns={columns3}
                                data={this.state.postsLikuidime}
                                defaultPageSize={10}
                                className="-striped -highlight mt-4 mr-3 ml-3"
                                pageText="Faqe"
                                nextText="Para"
                                rowsText="Rreshta"
                                previousText="Mbrapa"
                                noDataText="Nuk ka te dhena"
                                
                              />
                              }
                            
                            
                                </ModalNew> 
                                     </div>): null}
         <Row>
         <Col lg={3} sm={6}></Col>
              <Col lg={3} sm={6}>
              <label className="m-2">Nga : </label>
                <DatePicker
                  onChange={this.handleChange2}
                  value={this.state.pNga}
                  name="pDeri"
                  dateFormat="Pp"
                  className="mt-4"
                /></Col>
              <Col lg={3} sm={6}>
              <label className="m-2">Deri : </label>
                <DatePicker
                  onChange={this.handleChange1}
                  value={this.state.pDeri}
                  name="pDeri"
                  dateFormat="Pp"
                  className="mt-4"
                /></Col> 
                <Col lg={2} sm={6}>
                <button
                  onClick={() => this.handleClick()}
                  className="btn btn-primary ml-4 mt-3 "
                >
                  {" "}
                  Kerko
                </button>
              </Col>
            </Row>
                
                <Row className="mt-4">
                  <Col lg={3} sm={6}>
                  <a href="#Porosi-te-krijuara" onClick={() => this.TestA()}>
                    <StatsCard
                      bigIcon={<i className="pe-7s-ribbon text-link" />}
                      statsText="Porosi Te Krijuara"
                      statsValue={this.state.number}
                      statsIcon={<i className="fa fa-refresh" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  
                  </Col>
                  <Col lg={3} sm={6}>
                  <a href="#Pode-te-grumbulluara" onClick={() => this.TestB()}>
                    <StatsCard
                      bigIcon={<i className="pe-7s-wallet text-danger" />}
                      statsText="Grumbullime"
                      statsValue={this.state.number2}
                      statsIcon={<i className="fa fa-calendar-o" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  </Col>

                  <Col lg={3} sm={6}>
                  <a href="#Pode-Vetem-PorosiTeKrijuara" onClick={() => this.TestC()}>
                    <StatsCard
                      bigIcon={<i className="pe-7s-graph1 text-warning" />}
                      statsText="Vetem Porosi te Krijuara"
                      statsValue={this.state.number3}
                      statsIcon={<i className="fa fa-clock-o" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  </Col>
                  <Col lg={3} sm={6}>
                  <a href="#Pode-te-Deleguara" onClick={() => this.PodeDeleguar()}>
                    <StatsCard
                      bigIcon={<i className="pe-7s-graph1 icon-d" />}
                      statsText="Pode Deleguar ne korrier"
                      statsValue={this.state.number4}
                      statsIcon={<i className="fa fa-refresh" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3} sm={6}>
                  <a href="#Pod-Vetem-Grumbullim" onClick={() => this.VetemGrumbullim()}>
                    <StatsCard
                      bigIcon={<i className="pe-7s-car text-success" />}
                      statsText="Vetem Grumbullim"
                      statsValue={this.state.number5}
                      statsIcon={<i className="fa fa-calendar-o" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  </Col>
                  <Col lg={3} sm={6}>
                  <a href="#Pode-Vetem-Delegim" onClick={() => this.TestH()}>
                    <StatsCard
                      bigIcon={<i className="pe-7s-box1 text-primary" />}
                      statsText="Vetem Delegim"
                      statsValue={this.state.number6}
                      statsIcon={<i className="fa fa-refresh" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  </Col>
                  <Col lg={3} sm={6}>
                  <a href="#ObjektiDestinacionDorezim" onClick={() => this.ObjekteNeDestinacion()}>
                    <StatsCard
                      bigIcon={<i className="pe-7s-ribbon text-link" />}
                      statsText="Objekti ne Destinacion Per Dorezim"
                      statsValue={this.state.number7}
                      statsIcon={<i className="fa fa-refresh" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  
                  </Col>
                  <Col lg={3} sm={6}>
                  <a href="#Pode-te-kthyera-mbrapa" onClick={() => this.KthyerMbrapsht()}>
                  <StatsCard
                      bigIcon={<i className="pe-7s-note2 text-dark" />}
                      statsText="Kthyer Mbrapa"
                      statsValue={this.state.number8}
                      statsIcon={<i class="fa-solid fa-envelopes-bulk"></i>}
                      statsIconText="Statusi i fundit"
                    /></a>
                  </Col>
                  
                </Row>
                <Row>
                
                  <Col lg={3} sm={6}>
                  <a href="#Pode-te-Dorezuara-kthyer-pas" onClick={() => this.DorezuarPodeKthyerPas()}>
                  <StatsCard
                      bigIcon={<i className="pe-7s-note2 text-dark" />}
                      statsText="Objekti ne Destincion per dorezim/Kthyer pas"
                      statsValue={this.state.number9}
                      statsIcon={<i className="fa fa-calendar-o" />}
                      statsIconText="Statusi i fundit"
                    />
                    </a>
                  </Col>
                  
                  <Col lg={3} sm={6}>
                  <a href="#Pode-te-Dorezuara" onClick={() => this.DorezuarPode()}>
                  <StatsCard
                      bigIcon={<i className="pe-7s-note2 text-dark" />}
                      statsText="Dorezime"
                      statsValue={this.state.number10}
                      statsIcon={<i className="fa fa-calendar-o" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  </Col>
                  <Col lg={3} sm={6}>
                  <a href="#Pode-te-Padorezuar" onClick={() => this.MosDorezuarPode()}>
                  <StatsCard
                      bigIcon={<i className="pe-7s-note2 text-dark" />}
                      statsText="Mosdorezime"
                      statsValue={this.state.number11}
                      statsIcon={<i className="fa fa-calendar-o" />}
                      statsIconText="Statusi i fundit"
                    /></a>
                  </Col>

                  <Col lg={3} sm={6}>
                  <a href="#Pode-te-Padorezuar" onClick={() => this.MosDorezuarPodeRefuzime()}>
                <StatsCard
                    bigIcon={<i className="pe-7s-note2 text-dark" />}
                    statsText="Refuzimet"
                    statsValue={this.state.number12}
                    statsIcon={<i className="fa fa-calendar-o" />}
                    statsIconText="Statusi i fundit"
                    /></a>
                </Col>
                </Row>

                <Row>
                
                <Col lg={3} sm={6}>
                <a href="#Pode-Dorezim-Kthimit-Pas" onClick={() => this.DorezuarKthimeMbrapaPode()}>
                <StatsCard
                    bigIcon={<i className="pe-7s-note2 text-dark" />}
                    statsText="Dorezim i Kthimit Pas ne Klient"
                    statsValue={this.state.number13}
                    statsIcon={<i className="fa fa-calendar-o" />}
                    statsIconText="Statusi i fundit"
                    /></a>
                </Col>
               
                
              </Row>
                <label className="m-2">{' '}</label>
              </div>
            )}
          </div>
   
        <Row />
      </Grid>
      
    );
  }
}


const ModalNew = ({ handleClose, show, children, vlera,loading }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";
  let tsize = vlera.length;
  let vararray =[];
  let finalarray=[];


          for (var i = 0; i < tsize; i++) {
            vararray.push(vlera[i].POD);
            vararray.push(vlera[i].AgjensiaDestinacion);
            vararray.push(vlera[i].Agjensia_qe_Paguan);
            vararray.push(vlera[i].Data);
            vararray.push(vlera[i].Kod_Levizje);    
            vararray.push(vlera[i].Pershkrime);
            vararray.push(vlera[i].VleraKP);
            finalarray.push(vararray);
            vararray=[];
          }
  if(loading==true){
    
    return( <div className={showHideClassName}><section className="modal-main2"><label className="m-4">{" "}</label><LoadingSpinner /></section></div>)
  }else{



  return (
    <div className={showHideClassName}>
      <section className="modal-main2">
        {children}
       
        <button className="btn btn-primary m-3" onClick={handleClose}>
          Mbyll
        </button>
        <CSVLink data={finalarray}>
          
              <span data-notify="icon" className="pe-7s-download" />
              &nbsp; Eksporto
            </CSVLink>
      </section>
    </div>
  );
  }
};

const ModalGjurmo = ({ handleClose, show, children, vlera }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main2">
        {children}
        <button className="btn btn-primary m-3" onClick={handleClose}>
          Mbyll
        </button>
        
      </section>
    </div>
  );
};


style:{}

export default DashboardAgjent;
